import { REFERRAL_COOKIES_KEY } from "../../constants";

export const parseReferralFromUrl = (url) => {
  return url.includes('?r=') ? url.replace('?r=', '') : null;
};

export const getReferralFromCookies = () => {
  return localStorage.getItem(REFERRAL_COOKIES_KEY);
};
